import React, { createContext, useContext } from 'react';
import { ReactNode } from 'react';

const patientIdContext = createContext<number | undefined>(undefined);

export const usePatientIdContext = (): number | undefined => useContext(patientIdContext);

interface PatientIdContextProviderProps {
  patientId?: number;
  children: ReactNode;
}

const PatientIdContextProvider = ({ patientId, children }: PatientIdContextProviderProps) => (
  <patientIdContext.Provider value={patientId}>{children}</patientIdContext.Provider>
);

export default PatientIdContextProvider;
